import { cloneValue } from './cloneValue.ts';

export function cloneStoreState<T>(initialState: T): T {
  return cloneValue(initialState);
}
